(function () {
  'use strict';

  Array.prototype.forEach.call(document.querySelectorAll('[data-ld-buy]'), function (root) {
    var select = root.querySelector('[data-ld-select]');
    var data = root.querySelector('[data-ld-variants]');
    if (!select || !data) return;

    var variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var priceEl = root.querySelector('[data-ld-price]');
    var compareEl = root.querySelector('[data-ld-compare]');
    var stockEl = root.querySelector('[data-ld-stock]');
    var stockText = root.querySelector('[data-ld-stock-text]');
    var addBtn = root.querySelector('[data-ld-add]');

    var soldOutLabel = root.getAttribute('data-sold-out-label') || 'SOLD OUT';
    var cartLabel = root.getAttribute('data-cart-label') || 'ADD TO CART';

    function find(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    /* The buttons are the control the shopper sees; the select is hidden and
       carries `id` in the form. Clicking a value rewrites the chosen options,
       looks up the variant that matches all of them, and drives the select —
       so one code path updates price, stock and the submitted id. */
    var optionBtns = root.querySelectorAll('[data-ld-option-value]');
    var chosen = [];

    Array.prototype.forEach.call(optionBtns, function (btn) {
      var i = parseInt(btn.getAttribute('data-option-index'), 10);
      if (btn.classList.contains('is-active')) chosen[i] = btn.getAttribute('data-option-value');
    });

    function variantFor(opts) {
      for (var i = 0; i < variants.length; i++) {
        var vo = variants[i].options || [];
        var all = true;
        for (var k = 0; k < opts.length; k++) {
          if (opts[k] !== undefined && String(vo[k]) !== String(opts[k])) { all = false; break; }
        }
        if (all) return variants[i];
      }
      return null;
    }

    Array.prototype.forEach.call(optionBtns, function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.getAttribute('data-option-index'), 10);
        chosen[i] = btn.getAttribute('data-option-value');

        // only the row that changed re-marks itself
        Array.prototype.forEach.call(optionBtns, function (other) {
          if (parseInt(other.getAttribute('data-option-index'), 10) !== i) return;
          var on = other === btn;
          other.classList.toggle('is-active', on);
          other.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        var match = variantFor(chosen);
        if (!match) return;               // combination the product does not carry
        select.value = String(match.id);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    select.addEventListener('change', function () {
      var v = find(select.value);
      if (!v) return;

      if (priceEl) priceEl.textContent = v.price;

      if (compareEl) {
        if (v.compareAt) {
          compareEl.textContent = v.compareAt;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (stockText) stockText.textContent = v.stock;
      if (stockEl) stockEl.classList.toggle('ld__stock--out', !v.available);

      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? cartLabel : soldOutLabel;
      }
    });
  });
})();
